// src/dummyData/dummyPayoffs.tsx
import { PayoffDebt } from '../../ducks/debtPayoff';

export const dummyPayoffs: PayoffDebt[] = [
  {
    id: 1,
    name: 'Credit Card',
    current_balance: 5000,
    interest_rate: 22,
    minimum_payment: 150,
    status: 'paying'
  },
  {
    id: 2,
    name: 'Student Loan',
    current_balance: 15000,
    interest_rate: 7,
    minimum_payment: 200,
    status: 'paying'
  },
  {
    id: 3,
    name: 'Auto Loan',
    current_balance: 10000,
    interest_rate: 5,
    minimum_payment: 300,
    status: 'paying'
  },
  {
    id: 4,
    name: 'Medical Bill',
    current_balance: 2000,
    interest_rate: 0,
    minimum_payment: 100,
    status: 'paying'
  },
  {
    id: 5,
    name: 'Personal Loan',
    current_balance: 7000,
    interest_rate: 12,
    minimum_payment: 180,
    status: 'paying'
  },
];